import { AuthType } from "../types/auth";

export function getAuthType(): string {
  try {
    return __AUTH_TYPE__;
  } catch (err) {
    return AuthType.Basic;
  }
}
